import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileHeader from './MobileHeader';
import ThemeToggle from '@/components/common/ThemeToggle';

function Layout(): JSX.Element {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = (): void => {
      if (window.innerWidth >= 992) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const handleToggleSidebar = (): void => {
    setSidebarCollapsed(prev => !prev);
  };

  const handleOpenMobileMenu = (): void => {
    setMobileMenuOpen(true);
  };

  const handleCloseMobileMenu = (): void => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="app-layout" style={{ height: '100vh', overflow: 'hidden' }}>
      <Sidebar
        isCollapsed={sidebarCollapsed}
        onToggle={handleToggleSidebar}
        isMobileOpen={mobileMenuOpen}
        onMobileClose={handleCloseMobileMenu}
      />
      <MobileHeader onMenuClick={handleOpenMobileMenu} />
      <main
        className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}
        style={{
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: 'var(--spacing-lg)'
        }}>
          <Outlet />
        </div>
      </main>
      <div className="d-none d-lg-block">
        <ThemeToggle />
      </div>
    </div>
  );
}

export default Layout;